import { API_END_POINTS } from './networks/apiEndPoints';
import api from './networks/api';

export const loginService = async (payload) => {
  try {
    const response = await api.post(API_END_POINTS.LOGIN_SERVICE, payload);
    const data = response.data;

    if (data?.responseData?.success === true) {
      return data.responseData; 
    }

    throw new Error(data?.responseData?.message || 'Login failed');
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};
